import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import "./learn.css";
import GraphService from "../../services/graph.service";
import Loading from "../../assets/images/Loading.gif";

Chart.register(...registerables);

function MyProgressChart() {
  const [courses, setCourses] = useState([]);
  const [marks, setMarks] = useState([]);
  const [combineProgress, setCombineProgress] = useState([]);
  const [colors, setColors] = useState([])

  useEffect(() => {
    GraphService.getStudentProgress()
      .then((resp) => {
        console.log(resp.data);
        setCourses(resp.data.distrubuted.courses);
        setMarks(resp.data.distrubuted.grades);
        setCombineProgress(resp.data.combine);
        console.log(resp.data.distrubuted.grades);

        setColors(resp.data.distrubuted.courses.map(() => getRandomColor()));
      })
      .catch((e) => console.log(e));
  }, []);

 


  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  console.log(colors);

  const data = {
    labels: courses,
    datasets: [
      {
        label: "",
        data: marks,
        backgroundColor: colors,
        borderColor: ["transparent"],
        hoverOffset: 4,
      },
    ],
  };

  const centerText = {
    id: "",
  };

  const options = {
    cutout: 75,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      centerText: [centerText],
    },
  };

  return (
    <div
      className={
        marks.length > 0 ? "main-donut-container" : "main-donut-container gap0"
      }
    >
      <h6 style={{ textAlign: "left" }}>My Progress</h6>
      {marks.length > 0 ? (
        <>
          <div className="donut-container">
            <div>
              <Doughnut
                data={data}
                options={options}
                width="170px"
                height="170px"
              />
            </div>
            <div className="donut-data">
              {Array.isArray(combineProgress) ? (
                combineProgress.map((combProgress, index) => {
                  return (
                    <div className="donutDetails" key={index}>
                      <div className="donutDetails-flex">
                        <div
                          className={`donutDetails-color do-color`}
                          style={{backgroundColor: `${colors[index]}`}}
                        ></div>
                        <span title={combProgress.coursename}>
                          {combProgress.coursename
                            .split(" ")
                            .map((word) => word.charAt(0))
                            .join("")}
                        </span>
                      </div>
                      <span>{combProgress.max_grade}%</span>
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="inner-box">
            <div className="loading">
              <h1>No Progress yet</h1>
              <img src={Loading} width="200px" alt="" />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default MyProgressChart;
